/**
 * Lingshan 相关配置
 */
// 判断是否为 03 主机环境
export const IS_03_HOST = /^(dev-|test-|pre-)?(xy|w)\.03\.woa\.com$/.test(window.location.hostname);
// 从 URL 参数判断是否为 03 iframe 模式
export const IS_03_IFRAME = new URLSearchParams(window.location.search).get('iframe_type') === '03';
// 当前页面处于 03 环境的 iframe 中（需要通过 top 跳转）
export function is03Iframe() {
    return window.self !== window.top && (IS_03_HOST || IS_03_IFRAME);
}
